import React from 'react';
import divider from '../../images/svg/divider.svg';

var Separator = function Separator(props) {
  var _props$topPadding = props.topPadding,
      topPadding = _props$topPadding === void 0 ? "medium" : _props$topPadding,
      _props$bottomPadding = props.bottomPadding,
      bottomPadding = _props$bottomPadding === void 0 ? "medium" : _props$bottomPadding,
      _props$image = props.image,
      image = _props$image === void 0 ? '1' : _props$image,
      display = props.display,
      background = props.background;
  return /*#__PURE__*/React.createElement("div", {
    className: "\n    cb-separator\n    ".concat("cb-l-padding-".concat(topPadding, "--top"), "\n    ", "cb-l-padding-".concat(bottomPadding, "--bottom"), "\n    ", image === '0' ? "cb-separator--image" : '', "\n    ").concat(typeof display !== 'undefined' ? "cb-separator--".concat(display) : '', "\n    ").concat(typeof display !== 'undefined' ? "cb-separator__bg--".concat(background) : '', "\n    ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "container cb-l-padding--none"
  }, typeof display !== 'undefined' && display === 'solid' ? /*#__PURE__*/React.createElement("hr", null) : /*#__PURE__*/React.createElement("img", {
    src: divider
  })));
};

export default Separator;